export const state = () => ({
	answers: null,
	coverLetter: null,
	resume: null,
	customCoverLetter: null,
	universityCode: null,
	statusFilter: null,
});

export const mutations = {
	setAnswers(state: any, payload: any) {
		state.answers = payload;
	},

	setCoverLetter(state: any, payload: any) {
		state.coverLetter = payload;
	},

	setResume(state: any, payload: any) {
		state.resume = payload;
	},

	setCustomCoverLetter(state: any, payload: any) {
		state.customCoverLetter = payload;
	},

	setUniversityCode(state: any, payload: any) {
		state.universityCode = payload;
	},

	setStatusFilter(state: any, payload: any) {
		state.statusFilter = payload;
	},

	resetState(state: any) {
		Object.keys(state).forEach((key) => (state[key] = null));
	},
};

export const getters = {
	getAnswers: (state: any) => state.answers,
	getUniversityCode: (state: any) => state.universityCode,
	getStatusFilter: (state: any) => state.statusFilter,
	getCustomCoverLetter: (state: any) => state.customCoverLetter,
};

export const actions = {
	submit(state: any, jobUuid: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/jobs/${jobUuid}/job-applications`, {
					university: state.state.universityCode,
					cover_letter: state.state.customCoverLetter?.cover_letter,
				})
				.then((res) => {
					return Promise.all([
						state.dispatch('submitJobAnswers', res.data),
						state.dispatch('submitCoverLetter', res.data),
						state.dispatch('submitResume', res.data),
					])
						.then(() => {
							state.commit('resetState');
							resolve(null);
						})
						.catch((error) => reject(error));
				})
				.catch((err) => reject(err));
		});
	},

	async submitJobAnswers(state: any, jobApplication: any) {
		if (!state.state.answers) {
			return;
		}

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/job-applications/${jobApplication.uuid}/answers`, state.state.answers)
				.then(() => resolve(null))
				.catch((error) => reject(error));
		});
	},

	submitCoverLetter(state: any, jobApplication: any) {
		if (!state.state.coverLetter) {
			return;
		}

		const url = `/api/job-applications/${jobApplication.uuid}/documents`;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(url, state.state.coverLetter)
				.then(() => resolve(null))
				.catch((error) => reject(error));
		});
	},

	submitResume(state: any, jobApplication: any) {
		if (!state.state.resume) {
			return;
		}

		const url = `/api/job-applications/${jobApplication.uuid}/resume`;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(url, state.state.resume)
				.then(() => resolve(null))
				.catch((error) => reject(error));
		});
	},

	setAnswers(state: any, payload: any) {
		state.commit('setAnswers', payload);
	},

	setCoverLetter(state: any, payload: any) {
		state.commit('setCoverLetter', payload);
	},

	setResume(state: any, payload: any) {
		state.commit('setResume', payload);
	},

	updateCustomCoverLetter(state: any, payload: any) {
		state.commit('setCustomCoverLetter', payload);
	},

	setUniversityCode(state: any, payload: any) {
		state.commit('setUniversityCode', payload);
	},

	updateStatusFilter(state: any, payload: any) {
		state.commit('setStatusFilter', payload);
	},

	resetState(state: any) {
		state.commit('resetState');
	},
};
